// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Google Fonts import removed to avoid network dependency */
/* Importar sistema de temas */
/* Sistema de Temas para Whitelabel */
/* Variables base para todos los temas */
:root {
  --hamburger-color: #64748b;
  --color-blanco: #ffffff;
  --color-texto-principal: #ffffff;
  --color-texto-secundario: rgba(255, 255, 255, 0.8);
  --color-texto-terciario: rgba(255, 255, 255, 0.7);
  --color-borde: rgba(255, 255, 255, 0.2);
  --color-borde-hover: rgba(255, 255, 255, 0.3);
  --color-sombra: rgba(0, 0, 0, 0.1);
}

/* Tema IC (por defecto) */
:root,
[data-theme=ic] {
  --menu-bg-color: #FF6A00;
  --menu-hover-color: #FF7A23;
  --menu-active-color: #FF7A23;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

/* Tema AGILICE */
[data-theme=agilice] {
  --menu-bg-color: #00A7E1;
  --menu-hover-color: #00B4F2;
  --menu-active-color: #00B4F2;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

/* Tema REDMAT */
[data-theme=redmat] {
  --menu-bg-color: #FF9016;
  --menu-hover-color: #ED8716;
  --menu-active-color: #ED8716;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

/* Tema IC-CORP */
[data-theme=ic-corp] {
  --menu-bg-color: #64748B;
  --menu-hover-color: #475569;
  --menu-active-color: #475569;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

/* Variables SCSS para uso en componentes */
/* Mixin para obtener colores del tema */
/* Clases de tema para aplicar dinámicamente */
.theme-ic {
  --menu-bg-color: #ff7d28;
  --menu-hover-color: #DB6416;
  --menu-active-color: #DB6416;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

.theme-agilice {
  --menu-bg-color: #00A7E1;
  --menu-hover-color: #00B4F2;
  --menu-active-color: #00B4F2;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

.theme-redmat {
  --menu-bg-color: #FF9016;
  --menu-hover-color: #ED8716;
  --menu-active-color: #ED8716;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

.theme-ic-corp {
  --menu-bg-color: #64748B;
  --menu-hover-color: #475569;
  --menu-active-color: #475569;
  --menu-border-color: rgba(255, 255, 255, 0.2);
  --menu-text-color: #ffffff;
  --menu-text-hover: rgba(255, 255, 255, 0.9);
}

/* ========================================
   VARIABLES ESPECÍFICAS PARA DISEÑO MOBILE
   ======================================== */
/* Variables base para mobile - Tema IC (por defecto) */
:root,
[data-theme=ic] {
  /* Colores de fondo para mobile */
  --bg-menu-mobile: #FF6A00;
  --bg-sub-menu-mobile: #FF7A23;
  --bg-nested-sub-menu-mobile: #FF8A3A;
  --bg-hover-menu-mobile: #FF7A23;
  --bg-hover-sub-menu-mobile: #FF8A3A;
  --bg-hover-nested-sub-menu-mobile: #FF9A4D;
  --bg-menu-light: #ffffff;
  /* Colores de texto para mobile */
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  /* Colores de borde para mobile */
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  /* Colores de separador para mobile */
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

/* Tema AGILICE - Variables mobile */
[data-theme=agilice] {
  --bg-menu-mobile: #00A7E1;
  --bg-sub-menu-mobile: #00B4F2;
  --bg-nested-sub-menu-mobile: #00C1FF;
  --bg-hover-menu-mobile: #00B4F2;
  --bg-hover-sub-menu-mobile: #00C1FF;
  --bg-hover-nested-sub-menu-mobile: #00CEFF;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

/* Tema REDMAT - Variables mobile */
[data-theme=redmat] {
  --bg-menu-mobile: #FF9016;
  --bg-sub-menu-mobile: #ED8716;
  --bg-nested-sub-menu-mobile: #FF9A2A;
  --bg-hover-menu-mobile: #ED8716;
  --bg-hover-sub-menu-mobile: #FF9A2A;
  --bg-hover-nested-sub-menu-mobile: #FFA83D;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

/* Tema IC-CORP - Variables mobile */
[data-theme=ic-corp] {
  --bg-menu-mobile: #64748B;
  --bg-sub-menu-mobile: #475569;
  --bg-nested-sub-menu-mobile: #334155;
  --bg-hover-menu-mobile: #475569;
  --bg-hover-sub-menu-mobile: #334155;
  --bg-hover-nested-sub-menu-mobile: #1E293B;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

/* Variables SCSS para mobile - Mapeo de temas */
/* Mixin para obtener colores mobile del tema */
/* Clases de tema mobile para aplicar dinámicamente */
.theme-ic {
  --bg-menu-mobile: #FF6A00;
  --bg-sub-menu-mobile: #FF7A23;
  --bg-nested-sub-menu-mobile: #FF8A3A;
  --bg-hover-menu-mobile: #FF7A23;
  --bg-hover-sub-menu-mobile: #FF8A3A;
  --bg-hover-nested-sub-menu-mobile: #FF7A23;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

.theme-agilice {
  --bg-menu-mobile: #00A7E1;
  --bg-sub-menu-mobile: #00B4F2;
  --bg-nested-sub-menu-mobile: #00C1FF;
  --bg-hover-menu-mobile: #00B4F2;
  --bg-hover-sub-menu-mobile: #00C1FF;
  --bg-hover-nested-sub-menu-mobile: #00B4F2;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

.theme-redmat {
  --bg-menu-mobile: #FF9016;
  --bg-sub-menu-mobile: #ED8716;
  --bg-nested-sub-menu-mobile: #FF9A2A;
  --bg-hover-menu-mobile: #ED8716;
  --bg-hover-sub-menu-mobile: #FF9A2A;
  --bg-hover-nested-sub-menu-mobile: #ED8716;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

.theme-ic-corp {
  --bg-menu-mobile: #64748B;
  --bg-sub-menu-mobile: #475569;
  --bg-nested-sub-menu-mobile: #334155;
  --bg-hover-menu-mobile: #475569;
  --bg-hover-sub-menu-mobile: #334155;
  --bg-hover-nested-sub-menu-mobile: #475569;
  --bg-menu-light: #ffffff;
  --text-menu-mobile: #ffffff;
  --text-sub-menu-mobile: #ffffff;
  --text-nested-sub-menu-mobile: #ffffff;
  --text-hover-menu-mobile: #ffffff;
  --text-hover-sub-menu-mobile: #ffffff;
  --text-hover-nested-sub-menu-mobile: #ffffff;
  --border-menu-mobile: rgba(255, 255, 255, 0.2);
  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
  --separator-menu-mobile: rgba(255, 255, 255, 0.2);
  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);
  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);
}

/**
 * Submenús de escritorio portados a \`document.body\` (\`.menu-asteric-submenu-portal\`).
 * Están fuera del encapsulado del componente; se mantienen aquí con prefijo fijo.
 */
.menu-asteric-submenu-portal {
  position: static;
  z-index: 100;
  pointer-events: none;
}
.menu-asteric-submenu-portal > * {
  pointer-events: auto;
}
@keyframes menuAstericFadeInDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes menuAstericFadeInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.menu-asteric-submenu-portal .submenu {
  position: fixed;
  background-color: #ff6a00;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  opacity: 0;
  transform: translateY(-10px);
  animation: menuAstericFadeInDown 0.2s ease forwards;
  min-width: 200px;
  width: max-content;
  max-width: calc(100vw - 16px);
  pointer-events: auto;
  margin-top: 2px;
  will-change: auto;
  transform-origin: top left;
}
.menu-asteric-submenu-portal .submenu-list {
  list-style: none;
  margin: 0;
  padding: 8px 0;
  background-color: var(--menu-bg-color, #ff6a00);
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}
.menu-asteric-submenu-portal .submenu-list::-webkit-scrollbar {
  width: 5px;
}
.menu-asteric-submenu-portal .submenu-list::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.menu-asteric-submenu-portal .submenu-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.menu-asteric-submenu-portal .submenu-list::-webkit-scrollbar-track {
  background: transparent;
}
.menu-asteric-submenu-portal .submenu-item {
  position: relative;
}
.menu-asteric-submenu-portal .submenu-item.has-nested-submenu .submenu-link::after {
  content: "▶";
  float: right;
  margin-top: 4px;
  font-size: 8px;
  line-height: inherit;
  color: white;
  margin-left: 8px;
}
.menu-asteric-submenu-portal .submenu-item.submenu-item-active .submenu-link {
  background-color: var(--menu-active-color, #ff7a23);
  color: white;
}
.menu-asteric-submenu-portal .submenu-link {
  display: block;
  padding: 10px 15px;
  color: white;
  text-decoration: none;
  font-family: "Roboto", "Segoe UI", "Arial", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: 700;
  transition: background-color 0.2s ease;
  cursor: pointer;
}
.menu-asteric-submenu-portal .submenu-link:hover {
  background-color: var(--menu-hover-color, #ff7a23);
  color: white;
}
.menu-asteric-submenu-portal .submenu-link:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: -2px;
}
.menu-asteric-submenu-portal .nested-submenu {
  position: fixed;
  background-color: var(--menu-bg-color, #ff6a00);
  z-index: 100;
  opacity: 0;
  animation: menuAstericFadeInRight 0.2s ease forwards;
  width: 260px;
  max-height: calc(100vh - 16px);
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: auto;
  will-change: auto;
  transform-origin: top left;
}
.menu-asteric-submenu-portal .nested-submenu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.menu-asteric-submenu-portal .nested-submenu-item {
  position: relative;
}
.menu-asteric-submenu-portal .nested-submenu-link {
  display: block;
  padding: 10px 15px;
  color: white;
  text-decoration: none;
  font-family: "Roboto", "Segoe UI", "Arial", "Helvetica", sans-serif;
  font-size: 12px;
  font-weight: 700;
  transition: background-color 0.2s ease;
  cursor: pointer;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.menu-asteric-submenu-portal .nested-submenu-link:hover {
  background-color: var(--menu-hover-color, #ff7a23);
  color: white;
}
.menu-asteric-submenu-portal .nested-submenu-link:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: -2px;
}
@media (max-width: 480px) {
  .menu-asteric-submenu-portal .submenu-link,
  .menu-asteric-submenu-portal .nested-submenu-link {
    padding: 8px 12px;
    font-size: 12px;
  }
}

/* Global styles for menu-horizontal component */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
}

/* Global Custom Scrollbar Styles - Delicate and Minimalist */
* {
  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

/* Webkit scrollbar styling for all elements */
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

*::-webkit-scrollbar-corner {
  background: transparent;
}

/* Special styling for menu components */
.menu-container,
.mobile-menu {
  /* Override global styles for menu-specific scrollbars */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

.menu-container::-webkit-scrollbar,
.mobile-menu::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.menu-container::-webkit-scrollbar-thumb,
.mobile-menu::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.menu-container::-webkit-scrollbar-thumb:hover,
.mobile-menu::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

/* Hide scrollbars for submenus completely */
.mobile-submenu,
.mobile-nested-submenu,
.p-menubar-overlay {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mobile-submenu::-webkit-scrollbar,
.mobile-nested-submenu::-webkit-scrollbar,
.p-menubar-overlay::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles.scss","webpack://./src/app/styles/themes.scss","webpack://./src/app/styles/menu-portal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4DAAA;AAEA,8BAAA;ACFA,qCAAA;AAGA,wCAAA;AACA;EACE,0BAAA;EACA,uBAAA;EACA,gCAAA;EACA,kDAAA;EACA,iDAAA;EACA,uCAAA;EACA,6CAAA;EACA,kCAAA;ADEF;;ACCA,0BAAA;AACA;;EAEE,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADEF;;ACCA,iBAAA;AACA;EACE,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADEF;;ACCA,gBAAA;AACA;EACE,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADEF;;ACCA,iBAAA;AACA;EACE,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADEF;;ACCA,2CAAA;AAoCA,wCAAA;AAcA,8CAAA;AACA;EAVI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADnCJ;;AC4CA;EAdI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;AD1BJ;;ACuCA;EAlBI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADjBJ;;ACkCA;EAtBI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;ADRJ;;AC6BA;;6CAAA;AAIA,uDAAA;AACA;;EAEE,iCAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,iCAAA;EACA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,iCAAA;EACA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,qCAAA;EACA,iDAAA;EACA,sDAAA;EACA,4DAAA;AD9BF;;ACiCA,oCAAA;AACA;EACE,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADjCF;;ACoCA,mCAAA;AACA;EACE,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADpCF;;ACuCA,oCAAA;AACA;EACE,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADvCF;;AC0CA,gDAAA;AAwFA,+CAAA;AA8BA,qDAAA;AACA;EA1BI,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADnIJ;;AC4IA;EA9BI,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;AD7GJ;;AC0HA;EAlCI,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADvFJ;;ACwGA;EAtCI,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,0CAAA;EACA,wBAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EAEA,8CAAA;EACA,mDAAA;EACA,yDAAA;EAEA,iDAAA;EACA,sDAAA;EACA,4DAAA;ADjEJ;;AE7RA;;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;AFgSF;AE9RE;EACE,oBAAA;AFgSJ;AE7RE;EACE;IACE,UAAA;IACA,wBAAA;EF+RJ;AACF;AE5RE;EACE;IACE,UAAA;IACA,wBAAA;EF8RJ;AACF;AE3RE;EACE,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,0CAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AF6RJ;AE1RE;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,qDAAA;AF2RJ;AEzRI;EACE,UAAA;AF2RN;AExRI;EACE,0CAAA;EACA,kBAAA;AF0RN;AEvRI;EACE,0CAAA;AFyRN;AEtRI;EACE,uBAAA;AFwRN;AEpRE;EACE,kBAAA;AFsRJ;AEpRI;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AFsRN;AElRM;EACE,mDAAA;EACA,YAAA;AFoRR;AE/QE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mEAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,eAAA;AFiRJ;AE/QI;EACE,kDAAA;EACA,YAAA;AFiRN;AE9QI;EACE,2CAAA;EACA,oBAAA;AFgRN;AE5QE;EACE,eAAA;EACA,+CAAA;EACA,YAAA;EACA,UAAA;EACA,oDAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,0BAAA;AF8QJ;AE3QE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AF6QJ;AE1QE;EACE,kBAAA;AF4QJ;AEzQE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,mEAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AF2QJ;AEzQI;EACE,kDAAA;EACA,YAAA;AF2QN;AExQI;EACE,2CAAA;EACA,oBAAA;AF0QN;AEtQE;EACE;;IAEE,iBAAA;IACA,eAAA;EFwQJ;AACF;;AA9aA,gDAAA;AACA;EACE,sBAAA;AAibF;;AA9aA;EACE,SAAA;EACA,UAAA;EACA,iCAAA;AAibF;;AA9aA,6DAAA;AACA;EACE,8BAAA;EACA,qBAAA;EACA,+CAAA;AAibF;;AA9aA,8CAAA;AACA;EACE,UAAA;EACA,WAAA;AAibF;;AA9aA;EACE,uBAAA;AAibF;;AA9aA;EACE,oCAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAibF;;AA9aA;EACE,oCAAA;AAibF;;AA9aA;EACE,uBAAA;AAibF;;AA9aA,wCAAA;AACA;;EAEE,wDAAA;EACA,qBAAA;EACA,qDAAA;AAibF;;AA9aA;;EAEE,UAAA;EACA,WAAA;AAibF;;AA9aA;;EAEE,0CAAA;EACA,kBAAA;AAibF;;AA9aA;;EAEE,0CAAA;AAibF;;AA9aA,4CAAA;AACA;;;EAGE,qBAAA;EACA,wBAAA;AAibF;;AA9aA;;;EAGE,aAAA;AAibF","sourcesContent":["/* Google Fonts import removed to avoid network dependency */\n\n/* Importar sistema de temas */\n@use './app/styles/themes.scss';\n@use './app/styles/menu-portal.scss';\n\n/* Global styles for menu-horizontal component */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", sans-serif;\n}\n\n/* Global Custom Scrollbar Styles - Delicate and Minimalist */\n* {\n  /* Firefox scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n\n/* Webkit scrollbar styling for all elements */\n*::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n*::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Special styling for menu components */\n.menu-container,\n.mobile-menu {\n  /* Override global styles for menu-specific scrollbars */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n}\n\n.menu-container::-webkit-scrollbar,\n.mobile-menu::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.menu-container::-webkit-scrollbar-thumb,\n.mobile-menu::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n}\n\n.menu-container::-webkit-scrollbar-thumb:hover,\n.mobile-menu::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Hide scrollbars for submenus completely */\n.mobile-submenu,\n.mobile-nested-submenu,\n.p-menubar-overlay {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.mobile-submenu::-webkit-scrollbar,\n.mobile-nested-submenu::-webkit-scrollbar,\n.p-menubar-overlay::-webkit-scrollbar {\n  display: none;\n}\n","/* Sistema de Temas para Whitelabel */\n@use \"sass:map\";\n\n/* Variables base para todos los temas */\n:root {\n  --hamburger-color: #64748b;\n  --color-blanco: #ffffff;\n  --color-texto-principal: #ffffff;\n  --color-texto-secundario: rgba(255, 255, 255, 0.8);\n  --color-texto-terciario: rgba(255, 255, 255, 0.7);\n  --color-borde: rgba(255, 255, 255, 0.2);\n  --color-borde-hover: rgba(255, 255, 255, 0.3);\n  --color-sombra: rgba(0, 0, 0, 0.1);\n}\n\n/* Tema IC (por defecto) */\n:root,\n[data-theme=\"ic\"] {\n  --menu-bg-color: #FF6A00;\n  --menu-hover-color: #FF7A23;\n  --menu-active-color: #FF7A23;\n  --menu-border-color: rgba(255, 255, 255, 0.2);\n  --menu-text-color: #ffffff;\n  --menu-text-hover: rgba(255, 255, 255, 0.9);\n}\n\n/* Tema AGILICE */\n[data-theme=\"agilice\"] {\n  --menu-bg-color: #00A7E1;\n  --menu-hover-color: #00B4F2;\n  --menu-active-color: #00B4F2;\n  --menu-border-color: rgba(255, 255, 255, 0.2);\n  --menu-text-color: #ffffff;\n  --menu-text-hover: rgba(255, 255, 255, 0.9);\n}\n\n/* Tema REDMAT */\n[data-theme=\"redmat\"] {\n  --menu-bg-color: #FF9016;\n  --menu-hover-color: #ED8716;\n  --menu-active-color: #ED8716;\n  --menu-border-color: rgba(255, 255, 255, 0.2);\n  --menu-text-color: #ffffff;\n  --menu-text-hover: rgba(255, 255, 255, 0.9);\n}\n\n/* Tema IC-CORP */\n[data-theme=\"ic-corp\"] {\n  --menu-bg-color: #64748B;\n  --menu-hover-color: #475569;\n  --menu-active-color: #475569;\n  --menu-border-color: rgba(255, 255, 255, 0.2);\n  --menu-text-color: #ffffff;\n  --menu-text-hover: rgba(255, 255, 255, 0.9);\n}\n\n/* Variables SCSS para uso en componentes */\n$themes: (\n  'ic': (\n    'bg-color': #ff7d28,\n    'hover-color': #DB6416,\n    'active-color': #DB6416,\n    'border-color': rgba(255, 255, 255, 0.2),\n    'text-color': #ffffff,\n    'text-hover': rgba(255, 255, 255, 0.9)\n  ),\n  'agilice': (\n    'bg-color': #00A7E1,\n    'hover-color': #00B4F2,\n    'active-color': #00B4F2,\n    'border-color': rgba(255, 255, 255, 0.2),\n    'text-color': #ffffff,\n    'text-hover': rgba(255, 255, 255, 0.9)\n  ),\n  'redmat': (\n    'bg-color': #FF9016,\n    'hover-color': #ED8716,\n    'active-color': #ED8716,\n    'border-color': rgba(255, 255, 255, 0.2),\n    'text-color': #ffffff,\n    'text-hover': rgba(255, 255, 255, 0.9)\n  ),\n  'ic-corp': (\n    'bg-color': #64748B,\n    'hover-color': #475569,\n    'active-color': #475569,\n    'border-color': rgba(255, 255, 255, 0.2),\n    'text-color': #ffffff,\n    'text-hover': rgba(255, 255, 255, 0.9)\n  )\n);\n\n/* Mixin para obtener colores del tema */\n@mixin theme-colors($theme-name) {\n  $theme: map.get($themes, $theme-name);\n  \n  @if $theme {\n    --menu-bg-color: #{map.get($theme, 'bg-color')};\n    --menu-hover-color: #{map.get($theme, 'hover-color')};\n    --menu-active-color: #{map.get($theme, 'active-color')};\n    --menu-border-color: #{map.get($theme, 'border-color')};\n    --menu-text-color: #{map.get($theme, 'text-color')};\n    --menu-text-hover: #{map.get($theme, 'text-hover')};\n  }\n}\n\n/* Clases de tema para aplicar dinámicamente */\n.theme-ic {\n  @include theme-colors('ic');\n}\n\n.theme-agilice {\n  @include theme-colors('agilice');\n}\n\n.theme-redmat {\n  @include theme-colors('redmat');\n}\n\n.theme-ic-corp {\n  @include theme-colors('ic-corp');\n}\n\n/* ========================================\n   VARIABLES ESPECÍFICAS PARA DISEÑO MOBILE\n   ======================================== */\n\n/* Variables base para mobile - Tema IC (por defecto) */\n:root,\n[data-theme=\"ic\"] {\n  /* Colores de fondo para mobile */\n  --bg-menu-mobile: #FF6A00;\n  --bg-sub-menu-mobile: #FF7A23;\n  --bg-nested-sub-menu-mobile: #FF8A3A;\n  --bg-hover-menu-mobile: #FF7A23;\n  --bg-hover-sub-menu-mobile: #FF8A3A;\n  --bg-hover-nested-sub-menu-mobile: #FF9A4D;\n  --bg-menu-light: #ffffff;\n  \n  /* Colores de texto para mobile */\n  --text-menu-mobile: #ffffff;\n  --text-sub-menu-mobile: #ffffff;\n  --text-nested-sub-menu-mobile: #ffffff;\n  --text-hover-menu-mobile: #ffffff;\n  --text-hover-sub-menu-mobile: #ffffff;\n  --text-hover-nested-sub-menu-mobile: #ffffff;\n  \n  /* Colores de borde para mobile */\n  --border-menu-mobile: rgba(255, 255, 255, 0.2);\n  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n  \n  /* Colores de separador para mobile */\n  --separator-menu-mobile: rgba(255, 255, 255, 0.2);\n  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n}\n\n/* Tema AGILICE - Variables mobile */\n[data-theme=\"agilice\"] {\n  --bg-menu-mobile: #00A7E1;\n  --bg-sub-menu-mobile: #00B4F2;\n  --bg-nested-sub-menu-mobile: #00C1FF;\n  --bg-hover-menu-mobile: #00B4F2;\n  --bg-hover-sub-menu-mobile: #00C1FF;\n  --bg-hover-nested-sub-menu-mobile: #00CEFF;\n  --bg-menu-light: #ffffff;\n  \n  --text-menu-mobile: #ffffff;\n  --text-sub-menu-mobile: #ffffff;\n  --text-nested-sub-menu-mobile: #ffffff;\n  --text-hover-menu-mobile: #ffffff;\n  --text-hover-sub-menu-mobile: #ffffff;\n  --text-hover-nested-sub-menu-mobile: #ffffff;\n  \n  --border-menu-mobile: rgba(255, 255, 255, 0.2);\n  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n  \n  --separator-menu-mobile: rgba(255, 255, 255, 0.2);\n  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n}\n\n/* Tema REDMAT - Variables mobile */\n[data-theme=\"redmat\"] {\n  --bg-menu-mobile: #FF9016;\n  --bg-sub-menu-mobile: #ED8716;\n  --bg-nested-sub-menu-mobile: #FF9A2A;\n  --bg-hover-menu-mobile: #ED8716;\n  --bg-hover-sub-menu-mobile: #FF9A2A;\n  --bg-hover-nested-sub-menu-mobile: #FFA83D;\n  --bg-menu-light: #ffffff;\n  \n  --text-menu-mobile: #ffffff;\n  --text-sub-menu-mobile: #ffffff;\n  --text-nested-sub-menu-mobile: #ffffff;\n  --text-hover-menu-mobile: #ffffff;\n  --text-hover-sub-menu-mobile: #ffffff;\n  --text-hover-nested-sub-menu-mobile: #ffffff;\n  \n  --border-menu-mobile: rgba(255, 255, 255, 0.2);\n  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n  \n  --separator-menu-mobile: rgba(255, 255, 255, 0.2);\n  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n}\n\n/* Tema IC-CORP - Variables mobile */\n[data-theme=\"ic-corp\"] {\n  --bg-menu-mobile: #64748B;\n  --bg-sub-menu-mobile: #475569;\n  --bg-nested-sub-menu-mobile: #334155;\n  --bg-hover-menu-mobile: #475569;\n  --bg-hover-sub-menu-mobile: #334155;\n  --bg-hover-nested-sub-menu-mobile: #1E293B;\n  --bg-menu-light: #ffffff;\n  \n  --text-menu-mobile: #ffffff;\n  --text-sub-menu-mobile: #ffffff;\n  --text-nested-sub-menu-mobile: #ffffff;\n  --text-hover-menu-mobile: #ffffff;\n  --text-hover-sub-menu-mobile: #ffffff;\n  --text-hover-nested-sub-menu-mobile: #ffffff;\n  \n  --border-menu-mobile: rgba(255, 255, 255, 0.2);\n  --border-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --border-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n  \n  --separator-menu-mobile: rgba(255, 255, 255, 0.2);\n  --separator-sub-menu-mobile: rgba(255, 255, 255, 0.15);\n  --separator-nested-sub-menu-mobile: rgba(255, 255, 255, 0.1);\n}\n\n/* Variables SCSS para mobile - Mapeo de temas */\n$mobile-themes: (\n  'ic': (\n    'bg-menu': #FF6A00,\n    'bg-sub-menu': #FF7A23,\n    'bg-nested-sub-menu': #FF8A3A,\n    'bg-hover-menu': #FF7A23,\n    'bg-hover-sub-menu': #FF8A3A,\n    'bg-hover-nested-sub-menu': #FF9A4D,\n    'bg-menu-light': #ffffff,\n    'text-menu': #ffffff,\n    'text-sub-menu': #ffffff,\n    'text-nested-sub-menu': #ffffff,\n    'text-hover-menu': #ffffff,\n    'text-hover-sub-menu': #ffffff,\n    'text-hover-nested-sub-menu': #ffffff,\n    'border-menu': rgba(255, 255, 255, 0.2),\n    'border-sub-menu': rgba(255, 255, 255, 0.15),\n    'border-nested-sub-menu': rgba(255, 255, 255, 0.1),\n    'separator-menu': rgba(255, 255, 255, 0.2),\n    'separator-sub-menu': rgba(255, 255, 255, 0.15),\n    'separator-nested-sub-menu': rgba(255, 255, 255, 0.1)\n  ),\n  'agilice': (\n    'bg-menu': #00A7E1,\n    'bg-sub-menu': #00B4F2,\n    'bg-nested-sub-menu': #00C1FF,\n    'bg-hover-menu': #00B4F2,\n    'bg-hover-sub-menu': #00C1FF,\n    'bg-hover-nested-sub-menu': #00CEFF,\n    'bg-menu-light': #ffffff,\n    'text-menu': #ffffff,\n    'text-sub-menu': #ffffff,\n    'text-nested-sub-menu': #ffffff,\n    'text-hover-menu': #ffffff,\n    'text-hover-sub-menu': #ffffff,\n    'text-hover-nested-sub-menu': #ffffff,\n    'border-menu': rgba(255, 255, 255, 0.2),\n    'border-sub-menu': rgba(255, 255, 255, 0.15),\n    'border-nested-sub-menu': rgba(255, 255, 255, 0.1),\n    'separator-menu': rgba(255, 255, 255, 0.2),\n    'separator-sub-menu': rgba(255, 255, 255, 0.15),\n    'separator-nested-sub-menu': rgba(255, 255, 255, 0.1)\n  ),\n  'redmat': (\n    'bg-menu': #FF9016,\n    'bg-sub-menu': #ED8716,\n    'bg-nested-sub-menu': #FF9A2A,\n    'bg-hover-menu': #ED8716,\n    'bg-hover-sub-menu': #FF9A2A,\n    'bg-hover-nested-sub-menu': #FFA83D,\n    'bg-menu-light': #ffffff,\n    'text-menu': #ffffff,\n    'text-sub-menu': #ffffff,\n    'text-nested-sub-menu': #ffffff,\n    'text-hover-menu': #ffffff,\n    'text-hover-sub-menu': #ffffff,\n    'text-hover-nested-sub-menu': #ffffff,\n    'border-menu': rgba(255, 255, 255, 0.2),\n    'border-sub-menu': rgba(255, 255, 255, 0.15),\n    'border-nested-sub-menu': rgba(255, 255, 255, 0.1),\n    'separator-menu': rgba(255, 255, 255, 0.2),\n    'separator-sub-menu': rgba(255, 255, 255, 0.15),\n    'separator-nested-sub-menu': rgba(255, 255, 255, 0.1)\n  ),\n  'ic-corp': (\n    'bg-menu': #64748B,\n    'bg-sub-menu': #475569,\n    'bg-nested-sub-menu': #334155,\n    'bg-hover-menu': #475569,\n    'bg-hover-sub-menu': #334155,\n    'bg-hover-nested-sub-menu': #1E293B,\n    'bg-menu-light': #ffffff,\n    'text-menu': #ffffff,\n    'text-sub-menu': #ffffff,\n    'text-nested-sub-menu': #ffffff,\n    'text-hover-menu': #ffffff,\n    'text-hover-sub-menu': #ffffff,\n    'text-hover-nested-sub-menu': #ffffff,\n    'border-menu': rgba(255, 255, 255, 0.2),\n    'border-sub-menu': rgba(255, 255, 255, 0.15),\n    'border-nested-sub-menu': rgba(255, 255, 255, 0.1),\n    'separator-menu': rgba(255, 255, 255, 0.2),\n    'separator-sub-menu': rgba(255, 255, 255, 0.15),\n    'separator-nested-sub-menu': rgba(255, 255, 255, 0.1)\n  )\n);\n\n/* Mixin para obtener colores mobile del tema */\n@mixin mobile-theme-colors($theme-name) {\n  $theme: map.get($mobile-themes, $theme-name);\n  \n  @if $theme {\n    --bg-menu-mobile: #{map.get($theme, 'bg-menu')};\n    --bg-sub-menu-mobile: #{map.get($theme, 'bg-sub-menu')};\n    --bg-nested-sub-menu-mobile: #{map.get($theme, 'bg-nested-sub-menu')};\n    --bg-hover-menu-mobile: #{map.get($theme, 'bg-hover-menu')};\n    --bg-hover-sub-menu-mobile: #{map.get($theme, 'bg-hover-sub-menu')};\n    --bg-hover-nested-sub-menu-mobile: #{map.get($theme, 'bg-hover-menu')};\n    --bg-menu-light: #{map.get($theme, 'bg-menu-light')};\n    \n    --text-menu-mobile: #{map.get($theme, 'text-menu')};\n    --text-sub-menu-mobile: #{map.get($theme, 'text-sub-menu')};\n    --text-nested-sub-menu-mobile: #{map.get($theme, 'text-nested-sub-menu')};\n    --text-hover-menu-mobile: #{map.get($theme, 'text-hover-menu')};\n    --text-hover-sub-menu-mobile: #{map.get($theme, 'text-hover-sub-menu')};\n    --text-hover-nested-sub-menu-mobile: #{map.get($theme, 'text-hover-menu')};\n    \n    --border-menu-mobile: #{map.get($theme, 'border-menu')};\n    --border-sub-menu-mobile: #{map.get($theme, 'border-sub-menu')};\n    --border-nested-sub-menu-mobile: #{map.get($theme, 'border-nested-sub-menu')};\n    \n    --separator-menu-mobile: #{map.get($theme, 'separator-menu')};\n    --separator-sub-menu-mobile: #{map.get($theme, 'separator-sub-menu')};\n    --separator-nested-sub-menu-mobile: #{map.get($theme, 'separator-nested-sub-menu')};\n  }\n}\n\n/* Clases de tema mobile para aplicar dinámicamente */\n.theme-ic {\n  @include mobile-theme-colors('ic');\n}\n\n.theme-agilice {\n  @include mobile-theme-colors('agilice');\n}\n\n.theme-redmat {\n  @include mobile-theme-colors('redmat');\n}\n\n.theme-ic-corp {\n  @include mobile-theme-colors('ic-corp');\n}","/**\n * Submenús de escritorio portados a `document.body` (`.menu-asteric-submenu-portal`).\n * Están fuera del encapsulado del componente; se mantienen aquí con prefijo fijo.\n */\n.menu-asteric-submenu-portal {\n  position: static;\n  z-index: 100;\n  pointer-events: none;\n\n  > * {\n    pointer-events: auto;\n  }\n\n  @keyframes menuAstericFadeInDown {\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes menuAstericFadeInRight {\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  .submenu {\n    position: fixed;\n    background-color: #ff6a00;\n    border-radius: 0 0 4px 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 100;\n    opacity: 0;\n    transform: translateY(-10px);\n    animation: menuAstericFadeInDown 0.2s ease forwards;\n    min-width: 200px;\n    width: max-content;\n    max-width: calc(100vw - 16px);\n    pointer-events: auto;\n    margin-top: 2px;\n    will-change: auto;\n    transform-origin: top left;\n  }\n\n  .submenu-list {\n    list-style: none;\n    margin: 0;\n    padding: 8px 0;\n    background-color: var(--menu-bg-color, #ff6a00);\n    max-height: 80vh;\n    overflow-y: auto;\n\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;\n\n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(255, 255, 255, 0.3);\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n  }\n\n  .submenu-item {\n    position: relative;\n\n    &.has-nested-submenu .submenu-link::after {\n      content: '▶';\n      float: right;\n      margin-top: 4px;\n      font-size: 8px;\n      line-height: inherit;\n      color: white;\n      margin-left: 8px;\n    }\n\n    &.submenu-item-active {\n      .submenu-link {\n        background-color: var(--menu-active-color, #ff7a23);\n        color: white;\n      }\n    }\n  }\n\n  .submenu-link {\n    display: block;\n    padding: 10px 15px;\n    color: white;\n    text-decoration: none;\n    font-family: 'Roboto', 'Segoe UI', 'Arial', 'Helvetica', sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    transition: background-color 0.2s ease;\n    cursor: pointer;\n\n    &:hover {\n      background-color: var(--menu-hover-color, #ff7a23);\n      color: white;\n    }\n\n    &:focus {\n      outline: 2px solid rgba(255, 255, 255, 0.5);\n      outline-offset: -2px;\n    }\n  }\n\n  .nested-submenu {\n    position: fixed;\n    background-color: var(--menu-bg-color, #ff6a00);\n    z-index: 100;\n    opacity: 0;\n    animation: menuAstericFadeInRight 0.2s ease forwards;\n    width: 260px;\n    max-height: calc(100vh - 16px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    pointer-events: auto;\n    will-change: auto;\n    transform-origin: top left;\n  }\n\n  .nested-submenu-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .nested-submenu-item {\n    position: relative;\n  }\n\n  .nested-submenu-link {\n    display: block;\n    padding: 10px 15px;\n    color: white;\n    text-decoration: none;\n    font-family: 'Roboto', 'Segoe UI', 'Arial', 'Helvetica', sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    transition: background-color 0.2s ease;\n    cursor: pointer;\n    white-space: normal;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      background-color: var(--menu-hover-color, #ff7a23);\n      color: white;\n    }\n\n    &:focus {\n      outline: 2px solid rgba(255, 255, 255, 0.5);\n      outline-offset: -2px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .submenu-link,\n    .nested-submenu-link {\n      padding: 8px 12px;\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
